var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1491_6601",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1491_6601",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEOklEQVR4nO2dwWscVRzHPz9jUyko9NIiVQjoxVRQaSt6EBTRRmNz1x4EETz0D/AsPaj9KzyoOSRqQetVrFAtopeApSJ6aD2YSkuigUCb/XqYSV2SndmZ2ZnMb3Z/n9vOy7zf773P7nuTt/N2IAiCIAiCIAiCIAiCIAi6gbWdwKhIOgLMpy8vmNmfbeYz0Uh6QdKa/mdN0vNt5zWxSPpNu/m17bwmEkmHBsjY5lDb+VXlnrYTGIEDFctc02UhY0kIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcUYIcca9bScg6T7gNDADXDazr/Y4/ingaeB3YNHMNvcyviskPSBpZcfupyVJ+wucO5Ozg2qmwPn7JS3vOG9F0v31tK6DSDqb0aFfSpoecm5lIZKm0xiDeK/eVpaj7TnkqYzjrwFLw6RUIa1zKY1RJqc9oW0hV3PKFqhZSp+MhYo5jTeSDktazRl6JOn8ICllh6x0mDo/JNaqOryDtxYkPSHpxpCOuqAdE30ZIZL2SfpiSIybko7tbeudUlDKZ5L29Z1TSIikKUmLQ+q+Jel4O613Sirl76JSiggJGSMi6cmiUoYJSWV8WkDGibbb7ZqCUpYlPZpT/sjEyJB0VMk/dB9KeqahGMeUTLJ5XKxYJjU4gUt6Nu2bs5KONhGjP9icpM2+hm1JequhWMfTd3HdNDZnSHo77ZNtNiWdbCLWdsArAxq4JqmRRUpJJ2qW0tgwpWReWx8Q85cm4iHpgKReRkMfayQotUppdM6QNJsRtyep8K8TlVk6mSb7JwGHrs5Wxcx+BF4Ebo1QzRowl9bVFFlLPJZTtou217IKYWY/Ay9RTco6iYzL9WbVDJ0QAmBmP1Feyjpw0sx+aCar+umMELgrZZ6ko4exAZzqkgzomBAAM/semCNfygbwqpld3Jus6qNzQuCulFeAfwYUbwDzXZQBHRUCYGaXSD4p1/sOXwdeNrNv28lqdFq/62QUzOySpFngufTQd2Y26FPTGTotBCAV8HXbedRFZ4escSWEOCOEOKOMkA2gl1H2YA25dJ0jGcd7wL9FKyksxMxuAzcyil8vWs8Yk9UHq2Z2p5GIkj7PWd5+XxN4X6yS+5M/yOmX5TL1lXrCjqTTwMc5f9IDrgFbZertMFPAw+SPNG+Y2WLRCssKmQJWgMa+kBozrgKPlxmySl1lmdkWcAZoZkwcL24D75SdP0pf9prZNyRSsq64gqRvzlRZU6v8lDZJC8BHwMGqdYwpN4E3q+4EG+mxeZIOAu+SbEl7aJS6xoBrwCfAOTOr/P1/Lc8xlGTALMk+wcOMwaJlQe4AfwF/AFfMTC3nEwRBEARBEARBEARBEARBEATBbv4DUwl6R5S1skgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5e4541a49b9e018f50982b57dc678575.svg";
export { ForwardRef as ReactComponent };